<div *ngIf="transaccion"
  style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">

  <!-- Header row (siempre visible, clickable en mobile para expandir) -->
  <div (click)="onToggle()"
    style="padding: 14px 18px; display: flex; align-items: flex-start; gap: 12px; cursor: pointer;"
    class="card-header lg:cursor-default"
    [style.background]="expanded ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'"
    [class.lg:bg-white]="true">

    <!-- Icon envío/recibo -->
    <div class="card-icon" style="width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;"
      [style.background]="(transaccion.motivo === 'FONDEO WALLET' || transaccion.motivo.includes('Reversión')) ? '#f0fdf4' : '#eff6ff'">
      <mat-icon class="card-icon-mat" style="font-size: 22px; width: 22px; height: 22px; flex-shrink: 0;"
        [style.color]="(transaccion.motivo === 'FONDEO WALLET' || transaccion.motivo.includes('Reversión')) ? '#16a34a' : '#2563eb'">
        {{ (transaccion.motivo === 'FONDEO WALLET' || transaccion.motivo.includes('Reversión')) ? 'south_west' : 'north_east' }}
      </mat-icon>
    </div>

    <!-- Info central -->
    <div style="flex: 1; min-width: 0;">
      <!-- Nombre beneficiario + motivo -->
      <div style="font-weight: 700; font-size: 0.9rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        <span *ngIf="transaccion.motivo !== 'AC'">{{ beneficiario | uppercase }}</span>
        <span *ngIf="transaccion.tipoTransaccion !== 'RETIRO' && transaccion.motivo !== 'AC'">
          <span *ngIf="beneficiario"> — </span>{{ motivoDisplay | uppercase }}
        </span>
        <span *ngIf="transaccion.motivo === 'AC'">Transaccion Ves</span>
        <span *ngIf="transaccion.tipoTransaccion === 'RETIRO'">{{ transaccion.tipoTransaccion }}</span>
      </div>

      <!-- Fecha -->
      <div style="font-size: 0.78rem; color: #9ca3af; margin-top: 2px;">
        {{ fechaCreacionChile }}
      </div>

      <!-- Envío rechazado. Va en la cabecera y no sólo en los detalles porque
           en mobile los detalles arrancan colapsados, y es justo ahí donde el
           cliente ve las dos filas y se asusta. -->
      <div *ngIf="avisoDevolucion"
        style="display: flex; align-items: center; gap: 4px; margin-top: 4px; font-size: 0.74rem; font-weight: 600; color: #16a34a;">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; flex-shrink: 0;">undo</mat-icon>
        {{ devolucionEnVes ? 'Monto devuelto a tu saldo VES' : 'Monto devuelto a tu saldo' }}
      </div>
    </div>

    <!-- Status badge + expand arrow (mobile) / detail button (desktop) -->
    <div class="flex items-center gap-2" style="flex-shrink: 0;">
      <span *ngIf="estadoActualLabel"
        style="display: inline-block; padding: 3px 10px; border-radius: 6px; font-size: 0.7rem; font-weight: 700; white-space: nowrap;"
        [style.background]="getStatusBg()"
        [style.color]="getStatusColor()">
        {{ estadoActualLabel }}
      </span>
      <!-- Botón detalle solo desktop -->
      <button type="button" (click)="openDialog(); $event.stopPropagation()"
        class="hidden lg:flex"
        style="width: 32px; height: 32px; border-radius: 8px; border: 1px solid #e5e7eb; background: white; cursor: pointer; align-items: center; justify-content: center; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280; flex-shrink: 0;">more_horiz</mat-icon>
      </button>
      <!-- Flecha expand solo mobile -->
      <mat-icon class="lg:hidden"
        style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
        [style.transform]="expanded ? 'rotate(180deg)' : 'rotate(0)'">
        expand_more
      </mat-icon>
    </div>

  </div>

  <!-- Detalles de la transacción — siempre visible en desktop, colapsable en mobile -->
  <div [class.hidden]="!expanded" [class.lg:block]="true"
    style="border-top: 1px solid #f3f4f6;">

    <div style="padding: 12px 18px 14px; padding-left: 70px;" class="details-section card-details">

      <!-- Número de cuenta (si aplica) -->
      <div *ngIf="transaccion.numeroCuenta" style="font-size: 0.78rem; color: #6b7280; margin-bottom: 6px; font-family: monospace;">
        {{ transaccion.numeroCuenta }}
      </div>

      <!-- Montos -->
      <div class="flex flex-wrap gap-3" style="margin-bottom: 2px;">

        <!-- FONDEO WALLET -->
        <div *ngIf="transaccion.motivo === 'FONDEO WALLET' && transaccion.tipoTransaccion !== 'RETIRO' && transaccion.tipoTransaccion !== 'AC'"
          style="display: flex; align-items: center; gap: 6px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Monto:</span>
          <span style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">{{ transaccion.monedaOrigen | currency:'USD':'$' }} CLP</span>
        </div>

        <!-- AC -->
        <div *ngIf="transaccion.motivo === 'AC'"
          style="display: flex; align-items: center; gap: 6px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Cuenta:</span>
          <span style="font-size: 0.85rem; font-weight: 600; color: #374151; font-family: monospace;">{{ transaccion.cuentaBeneficiario?.numeroCuenta }}</span>
        </div>

        <!-- Envía (no fondeo, no retiro, no reversión) -->
        <ng-container *ngIf="transaccion.motivo !== 'FONDEO WALLET' && transaccion.motivo !== 'AC'">
          <div *ngIf="transaccion.tipoTransaccion !== 'RETIRO' && !transaccion.motivo.includes('Reversión transacción')"
            style="display: flex; align-items: center; gap: 6px;">
            <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">
              {{ transaccion.motivo !== 'AJUSTE DE BALANCE' ? 'Envía:' : 'Valor:' }}
            </span>
            <span style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">
              {{ transaccion.monedaOrigen | currency:'USD':'$' }} {{ transaccion.tipoMonedaOrigen }}
            </span>
          </div>

          <!-- Recibe (reversión) -->
          <div *ngIf="transaccion.tipoTransaccion !== 'RETIRO' && transaccion.motivo.includes('Reversión transacción')"
            style="display: flex; align-items: center; gap: 6px;">
            <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">
              {{ transaccion.motivo !== 'AJUSTE DE BALANCE' ? 'Recibe:' : 'Valor:' }}
            </span>
            <span style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">
              {{ transaccion.monedaOrigen | currency:'USD':'$' }} {{ transaccion.tipoMonedaDestino }}
            </span>
          </div>
        </ng-container>

        <!-- Recibe (no retiro, no AC) -->
        <div *ngIf="transaccion.tipoTransaccion !== 'RETIRO' && transaccion.tipoTransaccion !== 'AC' && transaccion.monedaDestino !== null"
          style="display: flex; align-items: center; gap: 6px;">
          <span *ngIf="transaccion.monedaDestino" style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Recibe:</span>
          <span *ngIf="transaccion.monedaDestino" style="font-size: 0.88rem; font-weight: 700; color: #2563eb;">
            {{ transaccion.monedaDestino | currency:'USD':'$' }} {{ transaccion.tipoMonedaDestino }}
          </span>
        </div>

        <!-- Tasa de conversión -->
        <div *ngIf="transaccion.tipoTransaccion !== 'RETIRO' && transaccion.motivo !== 'AC' && transaccion.motivo !== 'FONDEO WALLET'"
          style="display: flex; align-items: center; gap: 6px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Tasa:</span>
          <span style="font-size: 0.88rem; font-weight: 700; color: #7c3aed;">
            {{ tasaConversion ? (tasaConversion | number:'1.2-4') : '—' }}
          </span>
        </div>

      </div>

      <!-- Envío rechazado: el monto volvió al saldo (CLP o, para el chileno, VES). Ver `avisoDevolucion`. -->
      <div *ngIf="avisoDevolucion"
        style="display: flex; align-items: flex-start; gap: 8px; margin-top: 10px; padding: 9px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a; flex-shrink: 0; margin-top: 1px;">
          undo
        </mat-icon>
        <span style="font-size: 0.78rem; line-height: 1.4; color: #166534;">{{ avisoDevolucion }}</span>
      </div>

      <!-- Detalles RETIRO -->
      <div *ngIf="transaccion.tipoTransaccion === 'RETIRO'" class="flex flex-wrap gap-x-5 gap-y-1" style="margin-top: 4px;">
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Cuenta:</span>
          <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">{{ transaccion.aliasRetiro }}</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Banco:</span>
          <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">{{ transaccion.banco }}</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Nº Cuenta:</span>
          <span style="font-size: 0.82rem; font-weight: 600; color: #374151; font-family: monospace;">{{ transaccion.numeroCuentaRetiro }}</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Monto:</span>
          <span style="font-size: 0.88rem; font-weight: 700; color: #1e5a3f;">{{ transaccion.monedaDestino | currency:'USD':'$' }} CLP</span>
        </div>
      </div>

      <!-- Detalles ZELLE -->
      <div *ngIf="transaccion.tipoTransaccion === 'ZELLE'" class="flex flex-wrap gap-x-5 gap-y-1" style="margin-top: 4px;">
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Email/Tel:</span>
          <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">{{ transaccion.direccionZelle }}</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280;">Beneficiario:</span>
          <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">{{ transaccion.beneficiarioZelle }}</span>
        </div>
      </div>

    </div>

    <!-- Botón Ver Detalle solo mobile -->
    <div class="lg:hidden card-detail-btn" style="padding: 0 18px 14px;">
      <button type="button" (click)="openDialog(); $event.stopPropagation()"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 9px 16px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; cursor: pointer; font-size: 0.78rem; font-weight: 600; color: #2563eb; transition: background 0.2s ease;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0;">visibility</mat-icon>
        Ver Detalle
      </button>
    </div>

  </div>

</div>
